import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface PauseConfirmModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isPausing: boolean;
    size?: "sm" | "md" | "lg"
}

export function PauseConfirmModal(props: PauseConfirmModalProps) {
    const { t } = useTranslation();

    const getSize = () => {
        switch (props.size) {
            case "md":
                return "mw-500px"
            case "lg":
                return "mw-700px"
            default:
                return "mw-300px"
        }
    }

    return (
        <Modal
            show={props.open}
            onHide={props.onClose}
            dialogClassName={`modal-dialog-centered ${getSize()} h-auto`}
        >
            <div className="card">
                <div className="card-body">
                    <div className="mb-3 text-left">
                        <span>
                            {props.isPausing 
                                ? t('modal.pause.questionMessage')
                                : t('modal.resume.questionMessage')}
                        </span>
                    </div>
                    <div className="row text-center">
                        <div className="col-md-6">
                            <button 
                                type="button" 
                                className={`btn btn-${props.isPausing ? 'warning' : 'primary'} my-3`}
                                onClick={props.onConfirm}
                            >
                                {props.isPausing ? t('modal.pause.buttonConfirm') : t('modal.resume.buttonConfirm')}
                            </button>
                        </div>
                        <div className="col-md-6">
                            <button 
                                type="button" 
                                className="btn btn-active-light-primary my-3" 
                                onClick={props.onClose}
                            >
                                {t('crud.delete.buttonCancel')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}